module.exports = "<div class=\"content\">\n  <airport-selector\n    on-search=\"$ctrl.searchData($event)\">\n  </airport-selector>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/home.html
// module id = 611
// module chunks = 0